import apiClient from '@/services/apiClient';
import type { ScenarioGalleryItem } from '@/types/scenarioGallery';

export async function fetchScenarioGalleryFromApi(
	classIds?: number[]
): Promise<ScenarioGalleryItem[]> {
	return apiClient.get<ScenarioGalleryItem[]>('/scenario/gallery', {
		params: classIds?.length ? { classIds: classIds.join(',') } : undefined,
	});
}
